import * as Utils from '../common/utils';
/*interface IDataSvcQuery {
    db:string
    table:string
    id?:string,
    data?:Buffer, //for PUT/POST
    args?:string
    baseUrl?:string,
    headers?:any,
    responseInfo?:ResponseInfo
};*/
export class SuperDataSvc {
    get(db, table, id, args, baseUrl, headers) {
        return this.getJson(db, table, id, args, baseUrl, headers);
    }
    splitContentType(contentType) {
        if (contentType == null)
            return [null, null];
        let splitContentType = contentType.split(";");
        let baseContentType = splitContentType.length > 0 ? splitContentType[0].trim() : "";
        let encoding = splitContentType.length > 1 ? (splitContentType[1].slice(splitContentType[1].indexOf("charset=") + "charset=".length)).trim() : "utf8";
        return [baseContentType, encoding];
    }
    async getAny(db, table, id, args, baseUrl, headers, responseInfo) {
        if (responseInfo == null) {
            responseInfo = {};
        }
        let buf = await this.getBuffer(db, table, id, args, baseUrl, headers, responseInfo);
        if (buf != null) {
            let contentType = responseInfo.headers["Content-Type"];
            let [baseContentType, encoding] = this.splitContentType(contentType);
            if (!encoding)
                encoding = "utf8";
            if (baseContentType.startsWith("text/") || baseContentType.startsWith("application/javascript")) {
                return buf.toString(encoding);
            }
            else if (baseContentType.startsWith("application/octet-stream") || baseContentType.startsWith("application/binary") || baseContentType.startsWith("application/x-msdownload") || baseContentType.startsWith("image/")) {
                return buf;
            }
            else if (baseContentType.startsWith("application/json")) {
                return JSON.parse(buf.toString(encoding)); //default to json i guess.
            }
            else {
                //if(baseContentType.startsWith("application/octet-stream") || baseContentType.startsWith("application/binary") || baseContentType.startsWith("application/x-msdownload")) {}
                return buf;
            }
        }
        else {
            return null;
        }
    }
    putAny(db, table, id, data, args, baseUrl, headers) {
        let contentType = headers["Content-Type"];
        let [baseContentType, encoding] = this.splitContentType(contentType);
        if (baseContentType == null) {
            switch (typeof (data)) {
                case "string":
                    baseContentType = "text/plain";
                    break;
                case "object":
                    if (data instanceof Buffer)
                        baseContentType = "application/octet-stream";
                    baseContentType = "application/json";
                    break;
                default:
                    baseContentType = "application/json";
                    break;
            }
        }
        if (baseContentType.startsWith("text/")) {
            if (typeof (data) == "object") {
                if (data instanceof Buffer) {
                    data = data.toString(encoding);
                }
                else {
                    data = JSON.stringify(data);
                }
            }
            return this.putText(db, table, id, data, args, baseUrl, headers);
        }
        else if (baseContentType.startsWith("application/json") || (typeof (data) == "object" && !(data instanceof Buffer))) {
            if (typeof (data) == "string")
                data = new Buffer(data, encoding);
            else if (typeof (data) == "object" && data instanceof Buffer) {
                data = data.toString(encoding);
                data = JSON.parse(data);
            }
            data = JSON.parse(JSON.stringify(data));
            return this.putBuffer(db, table, id, data, args, baseUrl, headers);
        }
        else { //if(baseContentType.startsWith("application/octet-stream")) {            
            if (typeof (data) == "string")
                data = new Buffer(data, encoding);
            return this.putBuffer(db, table, id, data, args, baseUrl, headers);
        }
    }
    parseUrl(url) {
        return Utils.parseUrl(url);
    }
    //abstract getTextByPath(path:string,baseUrl?:string,headers?:any):Promise<string>; //is this really needed?
    async getTextByPath(url, headers, responseInfo) {
        var parsedUrl = this.parseUrl(url);
        return this.getText(parsedUrl.db, parsedUrl.table, parsedUrl.id, parsedUrl.args, null, headers); //BASEURL?            
    }
    async getDataByPath(url, headers, responseInfo) {
        var parsedUrl = this.parseUrl(url);
        return this.getAny(parsedUrl.db, parsedUrl.table, parsedUrl.id, parsedUrl.args, null, headers);
    }
    async postDataByPath(url, data, headers, responseInfo) {
        return null;
        //var parsedUrl = this.parseUrl(url);        
        //FIXMEL
        //return this.postBuffer()    
    }
    async putDataByPath(url, data, headers, responseInfo) {
        var parsedUrl = this.parseUrl(url);
        return this.putAny(parsedUrl.db, parsedUrl.table, parsedUrl.id, data, parsedUrl.args);
    }
}
//# sourceMappingURL=superdatasvc.js.map